module.exports = __webpack_public_path__ + "static/img/jersey2019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jersey2019.jpg
// module id = /rCS
// module chunks = 0